import {Model} from './model';
import {Unserializer} from './serialization';

export class SmsTemplate implements Model {
  smsTemplateId: number;
  name: string;
  description: string;
  message: string;
  created: Date;

  static copy(oldObj: SmsTemplate): SmsTemplate {
    const newObj = new SmsTemplate();
    newObj.smsTemplateId = oldObj.smsTemplateId;
    newObj.name = oldObj.name;
    newObj.description = oldObj.description;
    newObj.message = oldObj.message;
    newObj.created = Unserializer.date(oldObj.created);
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.smsTemplateId;
  }

  isNew(): boolean {
    return isNaN(this.smsTemplateId);
  }

  clone(): SmsTemplate {
    return SmsTemplate.copy(this);
  }
}
